import { factoryReducer, flattenStringMap } from '../../../reducers/utils'

import reducer from './reducer'
import { actions, factoryActions } from '../constants'

const factoryReducerID = factoryReducer(
  {
    registerType: factoryActions.INITIALIZE,
  },
  flattenStringMap(actions),
  reducer,
  (meta) => meta.ID,
)

export default factoryReducer(
  {
    registerType: factoryActions.INITIALIZE_TYPE,
  },
  flattenStringMap(actions),
  factoryReducerID,
  (meta) => meta.type,
)
